import { createFileRoute } from '@tanstack/react-router';
import { TrackDetail } from '@/components/tracks/TrackDetail.tsx';

export const Route = createFileRoute('/_app/tracks/$id/')({
  staticData: { orgScope: 'record', orgScopeList: '/tracks' },
  component: TrackDetailPage,
});

function TrackDetailPage() {
  const { id } = Route.useParams();

  return <TrackDetail trackId={id} />;
}
